export var FETCH_POPULAR_MATCHES = 'FETCH_POPULAR_MATCHES';
export var SUCCESS_FETCH_POPULAR_MATCHES = 'SUCCESS_FETCH_POPULAR_MATCHES';
export var FAILURE_FETCH_POPULAR_MATCHES = 'FAILURE_FETCH_POPULAR_MATCHES';
export var CLEAR_POPULAR = 'CLEAR_POPULAR';



// WEBPACK FOOTER //
// ./src/actions/popular.js